module.exports = __webpack_public_path__ + "img/minus.bb574f06.svg";